import { Box, Button, Drawer, IconButton, Typography, } from "@mui/material";
import EastIcon from '@mui/icons-material/East';
import { useDispatch } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import { getUsersAllData } from "../../../../actions/usersAllData";
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';


const MoodBoardsDrawer = ({ open, onClose, item }) => {

    // hooks
    const dispatch = useDispatch();

    // Local State
    const [loading, setloading] = useState(true);
    const [Data, setData] = useState([]);

    // Api calls for get Order
    const getData = useCallback(
        async () => {
            const res = await dispatch(getUsersAllData(item?._id, "moodboard"));
            setData(res?.data?.data);

            setloading(false);
        },
        [dispatch, item?._id]
    );

    useEffect(() => {
        getData()
    }, [open, item?._id]);



    return (
        <>
            <Drawer anchor="right"
                open={open}
                onClose={onClose}
                sx={{
                    "& .MuiDrawer-paper": {
                        top: "0px  !important",
                        backgroundColor: "#fafafa",
                        padding: "10px",
                    },
                    "& .css-i9fmh8-MuiBackdrop-root-MuiModal-backdrop": {
                        top: "0px !important"
                    }
                }}>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                    <Box sx={{ display: "flex", flexDirection: "column", marginTop: 1, p: 1 }}>
                        <Typography
                            className="sofiaRegular"
                            color="#222020"
                            variant="body1"
                            fontWeight="bold"
                            sx={{ fontSize: "16px" }}
                        >
                            Mood Boards
                        </Typography>
                        <Typography
                            variant="body2"
                            className="sofiaRegular"
                            sx={{ fontSize: "14px", color: "#1b1919" }}
                        >
                            {Data?.length} mood boards
                        </Typography>
                    </Box>
                    <IconButton sx={{ color: 'red', cursor: "pointer", backgroundColor: "transparent", "&:hover": { backgroundColor: "transparent" } }} onClick={onClose}>
                        <CancelRoundedIcon />
                    </IconButton>
                </Box>
                <Box sx={{ mt: 5 }}>
                    {Data?.length > 0 ? (Data.map((item, index) => (
                        <Box
                            key={index}
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                padding: "2px 10px",
                                height: "60px",
                                mb: 1,
                                backgroundColor: "#ffffff",
                                border: "1px solid #ececec",
                                borderRadius: "6px",
                                transition: "background-color 0.3s ease",
                                "&:hover": {
                                    cursor: "pointer"
                                },
                            }}
                        >
                            {/* Order Details */}
                            <Box sx={{ flex: 1, ml: 1, lineHeight: 0.9 }}>
                                <Typography
                                    className="sofiaRegular"
                                    sx={{ fontWeight: "bold", fontSize: 16, color: "#000" }}>
                                    {`${item.title} | [${item.products.length} items in board]`}
                                </Typography>
                                <Typography
                                    className="sofiaRegular"
                                    sx={{ fontSize: 14, color: "#000", }}>
                                    [{item.visibility}]
                                </Typography>
                            </Box>

                            {/* View Order Button */}
                            <Button
                                className="sofiaRegular"
                                sx={{
                                    fontWeight: "bold",
                                    fontSize: 14,
                                    color: "black",
                                    textTransform: "none",
                                    display: "flex",
                                    padding: "0px !important",
                                    bgcolor: "transparent", // Ensures initial background is transparent
                                    "&:hover": {
                                        bgcolor: "transparent", // Keeps background transparent on hover
                                    },
                                }}

                                endIcon={<EastIcon sx={{ fontSize: 14 }} />}
                            >
                                View Board
                            </Button>
                        </Box>
                    ))
                    ) : (
                        <Typography className="sofiaRegular" sx={{ color: "#000", textAlign: "center", mt: 2 }}>
                            No mood board found.
                        </Typography>
                    )}                </Box>

            </Drawer>
        </>
    )
}

export default MoodBoardsDrawer
